import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum ObstructionReportsSectionIds {
  obstruction = 'obstruction',
  location = 'location',
}

/**
 * @description Sections of the Obstruction Report detail page, in display order. Reports are read-only in the
 * admin (the API has no update endpoint); they can only be archived.
 */
export const obstructionReportsSections: SectionDefinition[] = [
  {
    id: ObstructionReportsSectionIds.obstruction,
    title: 'Obstruction',
    description: 'What was reported, how severe it is, and who reported it.',
    icon: ReportProblemOutlinedIcon,
  },
  {
    id: ObstructionReportsSectionIds.location,
    title: 'Location',
    description: 'Trail system and trail the obstruction is on.',
    icon: PlaceOutlinedIcon,
  },
]
